import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import TagsOutlined from '@ant-design/icons/TagsOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';

const colaboradores = {
  id: 'group-colaboradores',
  title: 'Colaboradores',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      // A visão de conjunto vem antes da lista: é por ela que o RH começa o dia, e é dela que se
      // chega a um colaborador específico.
      id: 'colaboradores-painel',
      title: 'Painel de RH',
      type: 'item',
      url: '/colaboradores/painel',
      icon: DashboardOutlined,
      // A mesma permissão da lista: quem pode ver os colaboradores pode ver o conjunto deles. Os
      // valores de custo dentro do painel é que exigem `colaboradores.remuneracao.view` — e sem
      // ela a tela diz por que o dinheiro está em branco, em vez de esconder o painel.
      permissions: ['colaboradores.colaboradores.view'],
      breadcrumbs: false
    },
    {
      id: 'colaboradores-list',
      title: 'Colaboradores',
      type: 'item',
      url: '/colaboradores/colaboradores',
      icon: TeamOutlined,
      permissions: ['colaboradores.colaboradores.view'],
      breadcrumbs: false
    },
    {
      // A fila de decisão do RH. A F4 entregou o reembolso inteiro no backend e sem tela — quem
      // tinha a alçada não tinha por onde exercê-la.
      id: 'colaboradores-reembolsos',
      title: 'Reembolsos',
      type: 'item',
      url: '/colaboradores/reembolsos',
      icon: WalletOutlined,
      permissions: ['colaboradores.reembolsos.view'],
      breadcrumbs: false
    },
    {
      id: 'colaboradores-catalogos',
      title: 'Catálogos',
      type: 'item',
      url: '/colaboradores/catalogos',
      icon: TagsOutlined,
      permissions: ['colaboradores.catalogos.manage'],
      breadcrumbs: false
    }
  ]
};

export default colaboradores;
